import { alpha, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  inputBox: {
    padding: theme.spacing(1),
    border: theme.custom.border.secondary,
    borderRadius: "4px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  input: {
    "& .MuiInputBase-root:before,& .MuiInputBase-root:after": {
      display: "none",
    },
  },
  add: {
    borderRadius: "0",
    borderLeft: theme.custom.border.secondary,
    padding: theme.spacing(0.75, 3.5, 0.75, 2.5),
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.custom.linkHover.color,
    },
    "& .MuiSvgIcon-root": {
      fontSize: "20px",
      marginRight: theme.spacing(1),
    },
  },
  empty: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(3),
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.26),
  },
  list: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  img: {
    display: "flex",
    marginRight: theme.spacing(2),
  },
  desc: {
    display: "flex",
    fontSize: "16px",
    letterSpacing: 0,
    lineHeight: "24px",
    color: theme.custom.color.mortar,
  },
  listItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 1.5),
    borderBottom: theme.custom.border.secondary,
  },
  listname: {
    fontSize: "14px",
    letterSpacing: "normal",
    lineHeight: "16px",
    fontWeight: "bold",
    color: theme.custom.color.blackRussian,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
    },
  },
  listBtnGrp: {
    display: "flex",
    flexDirection: "row",
  },
  delete: {
    display: "flex",
    color: theme.custom.color.pewter,
    padding: theme.spacing(0.75, 0),
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.custom.linkHover.color,
    },
  },
}));
